module.exports = __webpack_public_path__ + "img/bb_g3_t_antenna-04.e8bfc65e.svg";